import React from 'react';

import Button from '@/core/components/Button';
import { ButtonVariant } from '@/core/components/Button/Button';
import { ContainerWithMaxWidth } from '@/core/components/ContainerWithMaxWidth';
import useOpenGive from '@/core/hooks/useOpenGive';
import { AnalyticsEventType, useAnalyticsContext } from '@/core/lib/analytics/analytics.context';
import { useRouterContext } from '@/core/lib/router/router.context';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const HomeHero: React.FC<{
  overtitle?: React.ReactElement;
  title: string;
  content?: string;
  button?: { text: string; onClick: () => void; variant?: ButtonVariant };
}> = ({ overtitle, title, content, button }) => {
  const { onOpenGive } = useOpenGive();
  const { send } = useAnalyticsContext();
  const { t } = useTranslationContext(['home']);
  const { currentPage, push } = useRouterContext();

  const onClickOpenGive = async () => {
    await send({ event: AnalyticsEventType.CLICK_GIVE, where: 'HomePage-mobile' });
    const clone = currentPage.clone({ openGive: true });
    currentPage.updateCommon(prev => ({ ...prev, openAuth: true, redirectTo: clone.resolve() }));
    push(currentPage);
    onOpenGive();
  };

  return (
    <section className="!mt-0 md:px-6 lg:p-6 xl:px-0">
      <ContainerWithMaxWidth noPaddingXMobile>
        {overtitle}
        <div className="relative overflow-hidden bg-[url(../../../public/assets/home/banner-hero.jpg)] bg-cover bg-center md:rounded-3 lg:rounded-6">
          <div className="grid h-full min-h-[307px] items-center text-balance bg-[rgba(0,0,0,.30)] text-center text-content-button-primary lg:min-h-[508px]">
            <div className="space-y-5 px-4 pb-6 pt-14 text-center">
              <h1 className="text-balance font-abril text-[42px] leading-[50px] lg:text-64 lg:leading-[84px]">{title}</h1>
              {content && <p className="text-title font-semibold">{content}</p>}
              {button && (
                <>
                  <div className="max-lg:hidden">
                    <Button isInline onClick={button.onClick}>
                      {button.text}
                    </Button>
                  </div>
                  <div className="lg:hidden">
                    <Button isInline onClick={onClickOpenGive} variant="give" iconLeft="add">
                      {t('hero.give-button', { ns: 'home' })}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </ContainerWithMaxWidth>
    </section>
  );
};
